import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {downloadSliceInitialState} from "./initialState"

const downloadSlice = createSlice({
  name: "download",
  initialState: () => {
    const initialState = { ...downloadSliceInitialState};
    return initialState;
  },
  reducers: {
   setEmailString(state, action: PayloadAction<string>) {
      state.emailString = action.payload;
      return state;
    },
    setShowToast(state, action: PayloadAction<boolean>) {
        state.showToast = action.payload;
        return state;
      },
      setOpenModal(state, action: PayloadAction<boolean>) {
        state.openModal = action.payload;
        return state;
      },
  
  
  },
});

export const {
 setEmailString,
 setOpenModal,
 setShowToast
 

} = downloadSlice.actions;

export default downloadSlice;
